export default __webpack_public_path__ + "static/images/mailbox-30ccb1aefd1cf8c25039f2801bf70d30.png";